import React, { memo } from 'react';
import { formGroup, formControl, FormDataType } from '@core/utils/form';
import { CBody } from '@modules/common/CBody';
import { FormCheckbox, FormInput } from '@core/components/form';
import { WidgetConfirmProps } from '../types';
import { CardTitle } from 'reactstrap';

export function defineStatChartWidgetConfigForm() {
  return formGroup({
    upside: formControl<boolean>({ label: 'Upside down graph', initialValue: false }),
  });
}

export type StatChartWidgetConfigType = ReturnType<typeof defineStatChartWidgetConfigForm>;
export type StatChartWidgetConfigData = FormDataType<typeof defineStatChartWidgetConfigForm>;

export const StatChartWidgetConfig = memo((props: WidgetConfirmProps<StatChartWidgetConfigType, StatChartWidgetConfigData>) => {
  const { form, data } = props;
  return (
    <CBody>
      <CardTitle>Widget Settings</CardTitle>
      <FormCheckbox control={form.controls.upside} />
    </CBody>
  );
});
